// Import package components
import { useContext, useRef, useState } from "react";
import UIkit from "uikit";

// Import base components
import { AppContexts } from "../../../providers";

// Import common components
import Dialog from "../../common/Dialog";
import { removeGuideSection } from "./section_state";

const ResetToMaster = ({ onSectionReset }) => {
  const {
    deleteSection,
    selectedSection,
    setSelectedSection,
    rental,
    setRental,
  } = useContext(AppContexts.RentalsContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const resettingRef = useRef(false);

  const handleReset = async () => {
    if (resettingRef.current) return;
    const section = selectedSection;
    const rentalId = rental?.rental_id;
    if (
      !section?.welcome_guide_question_id || !rentalId ||
      !section.parent_id || String(section.parent_id) === "0" ||
      String(section.rental_id) !== String(rentalId)
    ) {
      setError("Select a customized property block to reset.");
      return;
    }

    resettingRef.current = true;
    setLoading(true);
    setError("");
    try {
      const [deleted, deleteError] = await deleteSection(
        section.welcome_guide_question_id,
      );
      if (
        deleteError || !deleted ||
        String(deleted.welcome_guide_question_id) !== String(section.welcome_guide_question_id) ||
        String(deleted.rental_id) !== String(rentalId)
      ) {
        throw new Error("Block reset was not confirmed");
      }

      onSectionReset?.(section, rentalId);
      setRental((current) => String(current?.rental_id) === String(rentalId)
        ? {
            ...current,
            welcome_guide: removeGuideSection(
              current.welcome_guide,
              section.welcome_guide_question_id,
            ),
          }
        : current);
      setSelectedSection((current) =>
        String(current?.welcome_guide_question_id) === String(section.welcome_guide_question_id)
          ? null
          : current,
      );
      UIkit.notification("Reset Successful.", "success");
      UIkit.modal("#reset-property").hide();
    } catch {
      setError("Unable to reset this block. Please try again.");
    } finally {
      resettingRef.current = false;
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog id="reset-property">
        <div className="uk-modal-dialog uk-modal-body">
          <button
            className="uk-modal-close-default"
            type="button"
            uk-close="true"
          ></button>
          <h2 className="uk-modal-title">Reset to Master</h2>
          <p>
            Are you sure you want to reset to master?{" "}
            <b>Warning: This step cannot be reversed.</b>
          </p>
          {error && <p role="alert" className="uk-text-danger">{error}</p>}
          <p className="uk-text-right">
            <button
              className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
              type="button"
            >
              Cancel
            </button>
            <button
              className="uk-button hms-btn hms-gray-btn"
              type="button"
              onClick={handleReset}
              disabled={loading}
            >
              {loading ? <div data-uk-spinner="ratio: 0.5;"></div> : "Reset"}
            </button>
          </p>
        </div>
      </Dialog>
    </>
  );
};

export default ResetToMaster;
